// extracted by mini-css-extract-plugin
module.exports = {"textButton":"TextButton_textButton__wQ6zT","tone-weak":"TextButton_tone-weak__qikGF"};